import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {

  constructor() { }

  data = new Subject<any>();
  fromWhere = new Subject<any>();
  date = new Subject<number>();
  contributionName:any;  
  showSuccessMessage: boolean = false;

  @Output() newMessageReceived =new EventEmitter<any>();
}
